import type { ReactNode } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ApiError } from '@/shared/api/api-error';
import { ForbiddenPage } from './forbidden-page';
import { NotFoundPage } from './not-found-page';
import { StatusPage } from './status-page';

/** `errorElement` das rotas: traduz erros de loader/render em páginas de status. */
export function RouteErrorPage(): ReactNode {
  const error = useRouteError();
  if (error instanceof ApiError && error.status === 403) return <ForbiddenPage />;
  if (error instanceof ApiError && error.status === 404) return <NotFoundPage />;
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  if (error instanceof ApiError && error.isUnavailable) {
    return (
      <StatusPage
        title="Serviço indisponível"
        description="Não foi possível falar com o servidor. Verifique sua conexão e tente novamente."
        traceId={error.traceId}
      />
    );
  }
  return (
    <StatusPage
      title="Algo deu errado"
      description="Ocorreu um erro inesperado. Tente novamente em instantes."
      traceId={error instanceof ApiError ? error.traceId : undefined}
    />
  );
}
